import React from 'react'
import { Row, Col, Card, Statistic } from 'antd'
import { DollarOutlined } from '@ant-design/icons'
import type { OrderStatistics as OrderStats } from '../types/order.types'

interface OrderStatisticsProps {
    statistics: OrderStats
}

export const OrderStatistics: React.FC<OrderStatisticsProps> = ({ statistics }) => {
    return (
        <Row gutter={16}>
            <Col span={8}>
                <Card>
                    <Statistic
                        title="Total Orders"
                        value={statistics.totalOrders}
                        prefix={<DollarOutlined />}
                    />
                </Card>
            </Col>
            <Col span={8}>
                <Card>
                    <Statistic
                        title="Total Revenue"
                        value={statistics.totalRevenue}
                        prefix="₹"
                        precision={0}
                    />
                </Card>
            </Col>
            <Col span={8}>
                <Card>
                    <Statistic
                        title="Delivered"
                        value={statistics.deliveredOrders}
                        valueStyle={{ color: '#3f8600' }}
                    />
                </Card>
            </Col>
        </Row>
    )
}
